import { useRef } from 'react'

interface NewRecipeLinkProps {
  newLink: () => void
}

function NewRecipeLink({ newLink }: NewRecipeLinkProps) {
  const containerRef = useRef<HTMLDivElement>(null)

  const handleNewLink = () => {
    newLink()

    // Scroll to bottom after adding new link
    setTimeout(() => {
      if (containerRef.current) {
        const scrollableParent = containerRef.current.closest(
          '.collapsible-section-content'
        )
        if (scrollableParent) {
          scrollableParent.scrollTop = scrollableParent.scrollHeight
        }
      }
    }, 0)
  }

  return (
    <div className="new-recipe-list-item" ref={containerRef}>
      <button
        className="new-recipe-list-item-add-button"
        onClick={handleNewLink}
      >
        +
      </button>
    </div>
  )
}

export default NewRecipeLink
